import React from 'react';
import { Avatar, Box, Chip, Typography } from '@mui/material';
import { ARIA_ESCALATION_QUEUE_MAP, ARIA_HANDOFF_STATUS_META } from '../ariaHandsoffConstants';

import { ariaAvatarFallbackSx } from '../ariaHandsoffSurfaces';

const AriaHandoffToolbar = ({ chat }) => {
  if (!chat) return null;

  const statusMeta = ARIA_HANDOFF_STATUS_META[chat.status];
  const queueMeta = ARIA_ESCALATION_QUEUE_MAP[chat.queue];

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1.5,
        px: 2,
        py: 1.5,
        borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
        bgcolor: 'background.paper',
        flexShrink: 0,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, minWidth: 0 }}>
        <Avatar
          src={chat.avatarUrl}
          alt={chat.userName}
          sx={{
            width: 34,
            height: 34,
            ...ariaAvatarFallbackSx,
            fontSize: '0.8125rem',
          }}
        >
          {chat.userName?.charAt(0)}
        </Avatar>
        <Box sx={{ minWidth: 0 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
            <Typography
              noWrap
              sx={{ fontWeight: 700, fontSize: '0.8125rem', color: 'text.primary' }}
            >
              {chat.userName}
            </Typography>
            {queueMeta ? (
              <Chip
                label={queueMeta.shortLabel}
                size="small"
                sx={{
                  height: 20,
                  fontSize: '0.625rem',
                  fontWeight: 700,
                  letterSpacing: '0.02em',
                  color: queueMeta.color,
                  bgcolor: queueMeta.bgcolor,
                  borderRadius: '6px',
                }}
              />
            ) : null}
            {statusMeta ? (
              <Chip
                label={statusMeta.label}
                size="small"
                sx={{
                  height: 20,
                  fontSize: '0.625rem',
                  fontWeight: 700,
                  color: statusMeta.color,
                  bgcolor: statusMeta.bgcolor,
                  borderRadius: '6px',
                }}
              />
            ) : null}
          </Box>
          <Typography
            noWrap
            variant="caption"
            sx={{ color: 'text.secondary', fontSize: '0.6875rem' }}
          >
            {chat.memberMeta || chat.userEmail}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default AriaHandoffToolbar;
